/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCloudDrizzle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M8.114.295a8.75 8.75 0 019.192 5.955h.7a5.752 5.752 0 015.623 4.575 5.75 5.75 0 01-3.322 6.442.75.75 0 11-.602-1.374 4.25 4.25 0 00-1.7-8.143h-1.26a.75.75 0 01-.725-.563 7.25 7.25 0 10-11.546 7.477.75.75 0 11-.936 1.172A8.75 8.75 0 018.114.296zM8.006 12.25a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75zm8 0a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75zm-4 2a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75zm-4 4a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75zm8 0a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75zm-4 2a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75z'
        />
      </g>
      <defs>
        <clipPath id='cloud-drizzle_svg__clip0_126_10409'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCloudDrizzle;
